import { executeRequest, Request } from '@jfs/network'
import { Config } from 'react-native-config'
import { APIEndPoints } from './APIEndpoints'
import { sitConfig } from './config'

const responseParser = (response: any) => {
  const { data } = response
  if (data?.responseStatus?.code === '000') {
    const {
      authInfo: { fieldDetails, fieldValues },
    } = data?.responseObj
    const state = fieldValues?.map((item: any, index: any) => {
      return {
        id: index,
        name: item.stateName,
        city: item.cityList,
      }
    })
    const redData = {
      fieldDetails,
      state,
    }
    return redData
  } else {
    const errorMsg = {
      errorCode: data?.error?.code,
      errorMessage: data?.error?.message,
    }
    throw errorMsg
  }
}

const body = (billerMasterId: number) => {
  return {
    category: {
      id: billerMasterId,
    },
    domain: {
      id: 'PayMyBill',
      name: 'PayMyBill',
      transactionType: 'BUY',
      description: 'This is for the buy case',
    },
    initiatingEntity: {
      entityId: Config.REACT_APP_CHANNEL_ID,
      channelId: Config.REACT_APP_CHANNEL_ID,
    },
  }
}

export const getLocationList = async (tokens: any, userAccessToken: any, billerMasterId: number) => {
  const config = sitConfig(tokens)
  const request: Request<{}> = {
    apiPath: APIEndPoints.getLocationList,
    method: 'POST',
    body: body(billerMasterId),
    config: config,
    headers: {
      'Content-Type': 'application/json',
      Authorization: userAccessToken,
    },
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}
